import { render, staticRenderFns } from "./HistoriaClinicaEdicionPorIdPacienteClinica.vue?vue&type=template&id=6a74da37"
import script from "./HistoriaClinicaEdicionPorIdPacienteClinica.vue?vue&type=script&lang=js"
export * from "./HistoriaClinicaEdicionPorIdPacienteClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports